export function setOrganizationOrders(state, organizationOrders) {
    state.organizationOrders = organizationOrders;
}

export function setEventOrders(state, eventOrders) {
    state.eventOrders = eventOrders;
}